export default __webpack_public_path__ + "static/odd-background-64952e389132f79788497be6a0de3c89.png";